import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { inr } from "@/lib/api";
import { Heart, ShoppingBag, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Wishlist() {
  const nav = useNavigate();
  const { wishlist, toggleWishlist, addToCart } = useApp();

  const moveToBag = (w) => {
    addToCart({ id: w.id, name: w.name, price: w.price, images: [w.image] }, "M", 1);
    toggleWishlist({ id: w.id });
    toast.success("Moved to bag");
  };

  if (wishlist.length === 0) return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <Heart size={48} className="mx-auto text-muted-foreground" />
      <h1 className="font-display text-4xl font-black mt-6">Your wishlist is empty</h1>
      <p className="text-muted-foreground mt-2">Tap the heart on any product to save it here.</p>
      <Button data-testid="wl-shop-btn" onClick={() => nav("/men")} className="mt-8 bg-[#8B2E2E] hover:bg-[#6f2323]">Browse products</Button>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <h1 className="font-display text-4xl font-black mb-8">Your Wishlist <span className="text-[#8B2E2E]">({wishlist.length})</span></h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {wishlist.map((w) => (
          <div key={w.id} data-testid={`wl-${w.id}`} className="group">
            <Link to={`/product/${w.id}`} className="block relative overflow-hidden rounded-md bg-[#F0EFEB] aspect-[3/4]">
              <img src={w.image} alt={w.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </Link>
            <div className="pt-3">
              <p className="label-tag">{w.subcategory}</p>
              <h3 className="font-display text-lg leading-tight mt-1">{w.name}</h3>
              <p className="font-semibold mt-1">{inr(w.price)}</p>
              <div className="mt-3 flex gap-2">
                <Button size="sm" data-testid={`wl-add-${w.id}`} onClick={() => moveToBag(w)} className="flex-1 bg-[#0A0A0A] hover:bg-[#8B2E2E] text-xs uppercase tracking-widest">
                  <ShoppingBag size={12} className="mr-1" /> Move to bag
                </Button>
                <button data-testid={`wl-remove-${w.id}`} onClick={() => { toggleWishlist({ id: w.id }); toast.info("Removed"); }} className="p-2 border border-black/20 hover:border-[#8B2E2E] hover:text-[#8B2E2E] transition-colors">
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
